import React from 'react';
import { useLanguage } from '../hooks/useLanguage';
import OptimizedImage from './OptimizedImage';

const Gallery = () => {
  const { t } = useLanguage();

  const images = [
    { src: '/images/gallery/e3371dd3_wow-tour-2.jpg', altKey: 'gallery.altBoatTour' },
    { src: '/images/gallery/3070fd10_wow-jet-ski.jpg', altKey: 'gallery.altJetSki' },
    { src: '/images/gallery/Dauphins_sunset.png', altKey: 'gallery.altDolphins' },
    { src: '/images/gallery/SpeddBoat_Fuengirola.png', altKey: 'gallery.altSpeedboat' },
    { src: '/images/gallery/Party Boat.jpg', altKey: 'gallery.altPartyBoat' },
    { src: '/images/gallery/IMG_2624.JPG', altKey: 'gallery.altMarina' },
    { src: '/images/gallery/Sunset.jpg', altKey: 'gallery.altSunset' },
    { src: '/images/gallery/wownautic fishing.jpg', altKey: 'gallery.altFishing' },
    { src: '/images/gallery/WhatsApp Image 2025-06-11 à 12.47.07_6952917a.jpg', altKey: 'gallery.altGroup' },
    { src: '/images/gallery/7845c63a_fishing.jpg', altKey: 'gallery.altFishing' },
    { src: '/images/gallery/146.jpg', altKey: 'gallery.altCoast' },
    { src: '/images/gallery/WhatsApp Image 2025-06-11 à 12.47.12_a3d5d8e9.jpg', altKey: 'gallery.altFamily' },
    { src: '/images/gallery/Trolling_fishing.jpg', altKey: 'gallery.altTrolling' },
    { src: '/images/gallery/2.jpg', altKey: 'gallery.altCoast' },
  ];

  return (
    <section id="gallery" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-5xl font-bold text-primary-950 mb-4">{t('sections.galleryTitle')}</h2>
          <p className="text-gray-600">{t('sections.gallerySubtitle')}</p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 auto-rows-[200px]">
          {images.map(({ src, altKey }, i) => (
            <div
              key={src}
              className={`rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 group relative ${
                i === 0 || i === 5 ? 'md:col-span-2 md:row-span-2' : ''
              }`}
            >
              <OptimizedImage
                src={src}
                alt={t(altKey)}
                width={400}
                height={200}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
